import React, { useState, useEffect } from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import "./AccountingTable.scss";
import { ListTransactionHistory } from "../../util/API/accounting";
import CSVImage from "../../images/csv-file.png";
import { CSVLink } from "react-csv";

function AccountingModalTable({ selectedData }) {
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [transactionList, setTransactionList] = useState([]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (index) => {
    if (openAccordion === index) {
      setOpenAccordion(null);
    } else {
      setOpenAccordion(index);
    }
  };

  useEffect(() => {
    const getModalData = async () => {
      const transactionHistory = await ListTransactionHistory(
        selectedData[0].vacctstructure.acctID,
        selectedData[0].vacctstructure.currCode
      );

      if (transactionHistory.payload.body == undefined) {
        console.log("failed here");
      } else {
        if (transactionHistory.payload.body.record.length) {
          setTransactionList(transactionHistory.payload.body.record);
        } else {
          setTransactionList([transactionHistory.payload.body.record]);
        }
      }
      setLoading(false);
    };
    getModalData();
  }, [selectedData]);

  function formatTransferTime(transferTime) {
    const parts = transferTime.split(" ");
    const formattedDate = parts[0].slice(2).replace(/-/g, "-");
    return (
      <>
        {formattedDate}
        <br />
        {parts[1]}
      </>
    );
  }

  //Printing a CSV is done below
  // Add your title here
  const titleRow = [
    `Charts of Accounts - ${selectedData[0].vacctstructure.acctID} - ${selectedData[0].vacctstructure.firstName} ${selectedData[0].vacctstructure.lastName}`,
  ];

  const csvData = [
    // Add the title row as the first row
    titleRow,
    // Add an empty row to separate the title from the header
    [],
    //These will be header columns
    [
      "Date",
      "Transaction Type",
      "Transaction ID",
      "Currency",
      "Debit",
      "Credit",
    ],
    // Add the data rows
    ...transactionList.map((row) => [
      row.Vtranshistory.transTime,
      row.Vtranshistory.transtypelabel,
      row.Vtranshistory.referenceTXID,
      row.Vtranshistory.currID,
      row.Vtranshistory.amount > 0 ? row.Vtranshistory.amount : "-",
      row.Vtranshistory.amount < 0 ? row.Vtranshistory.amount : "-",
    ]),
  ];

  return (
    <div>
      <div className="text-end pb-3">
        <CSVLink
          data={csvData}
          filename={`Charts of Accounts - ${selectedData[0].vacctstructure.acctID} - ${selectedData[0].vacctstructure.firstName}${selectedData[0].vacctstructure.lastName}.csv`}
        >
          <img src={CSVImage} className="excel-icon" />
        </CSVLink>{" "}
      </div>
      {transactionList.length ? (
        <div>
          <TableHead>
            <TableRow className="detail-header-colour">
              <TableCell align="left" className="">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Date</p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Transaction Type</p>
                </div>
              </TableCell>

              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Transaction ID</p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Currency</p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Debit</p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Credit</p>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactionList.map((row, index) => (
              <React.Fragment key={index}>
                <TableRow>
                  <TableCell style={{ width: 150 }} align="left">
                    <p className="account-detail-rows">
                      {row.Vtranshistory.transTime}
                    </p>
                  </TableCell>

                  <TableCell style={{ width: 150 }} align="left">
                    <div className="transaction-table-address-container">
                      <p className="account-detail-rows ">
                        {row.Vtranshistory.transtypelabel}
                      </p>
                    </div>
                  </TableCell>
                  <TableCell style={{ width: 150 }} align="left">
                    <div className="transaction-table-address-container">
                      <p className="account-detail-rows">
                        {" "}
                        {row.Vtranshistory.referenceTXID}
                      </p>
                    </div>
                  </TableCell>

                  <TableCell style={{ width: 150 }} align="left">
                    <p className="account-detail-rows ">
                      {row.Vtranshistory.currID}
                    </p>
                  </TableCell>
                  <TableCell style={{ width: 150 }} align="left">
                    <p className="account-detail-rows ">
                      {row.Vtranshistory.amount > 0 ? (
                        `$ ${row.Vtranshistory.amount}`
                      ) : (
                        <></>
                      )}
                    </p>
                  </TableCell>
                  <TableCell style={{ width: 150 }} align="left">
                    <p className="account-detail-rows ">
                      {row.Vtranshistory.amount < 0 ? (
                        `$ ${row.Vtranshistory.amount}`
                      ) : (
                        <></>
                      )}
                    </p>
                  </TableCell>
                </TableRow>
                {/* {openAccordion === index && (
        <TableRow>
          <TableCell colSpan={9}>
            <AccountingTableDetailsRow />
          </TableCell>
        </TableRow>
      )} */}
              </React.Fragment>
            ))}
          </TableBody>
        </div>
      ) : (
        <div>
          <TableHead>
            <TableRow className="detail-header-colour">
              <TableCell align="left" className="">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Date</p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Account Type</p>
                </div>
              </TableCell>

              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Account Name</p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Debit</p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers">Credit</p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers"></p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers"></p>
                </div>
              </TableCell>
              <TableCell align="left" className="accounting-detail-headers">
                <div className="header-cell-content">
                  <p className="accounting-detail-headers"></p>
                </div>
              </TableCell>

              <TableCell
                // className="accounting-detail-headers d-flex justify-content-right"
                align="right"
              >
                <div className="header-cell-content">
                  <p className="accounting-detail-headers"></p>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
        </div>
      )}
      {/* <AccountingDetailModal open={open} handleClose={handleClose} /> */}
    </div>
  );
}

export default AccountingModalTable;
